import { firebase } from "../../config/firebase/firebase-config";
import moment from "moment";
import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import CloudDownloadOutlinedIcon from "@material-ui/icons/CloudDownloadOutlined";
import StorageOutlinedIcon from "@material-ui/icons/StorageOutlined";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import AppAnimate from "../../components/ui/AppAnimate/AppAnimate";
import { AppState } from "../../redux/reducers/rootReducer";
import { useStyles } from "../../shared/styles/useStyles";
import {
  uiCloseErrorAlert,
  uiCloseModalAdd,
  uiCloseModalDelete,
  uiCloseModalEdit,
  uiCloseSuccessAlert,
  uiOpenModalAdd,
} from "../../redux/actions/uiActions";
import { CustomizedSearch } from "../../components/custom/CustomizedSearch";
import { CorrespondenceTable } from "../../components/correspondence-module/correspondence/CorrespondenceTable";
import CustomizedDialog from "../../components/custom/CustomizedDialog";
import {
  setActiveCorrespondence,
  startLoadMoreCorrespondences,
  startLoadAllCorrespondences,
} from "../../redux/actions/correspondenceActions";
import { CorrespondenceForm } from "../../components/correspondence-module/correspondence/CorrespondenceForm";
import {
  loadCorrespondenceManagment,
  setActiveCorrespondenceDocManagment,
} from "../../redux/actions/documentManagmentActions";
import { filterCorrespondence } from "../../helpers/filteredCorrespondence";
import { MyAlert } from "../../components/custom/MyAlert";
import { CustomizedWindow } from "../../components/custom/CustomizedWindow";
import { SettledDetails } from "../../components/document-managment/correspondence/SettledDetails";
import { uiCloseModalSee } from "../../redux/actions/uiActions";
import { setActiveExternalSender } from "../../module/admin/redux/actions/usersActions";
import { arraySearch } from "../../redux/actions/searchActions";
import { CorrespondenceInputType, InternalCorrespondenceStatus } from "../../enums/enums";
import DatePickerRange from "../../components/ui/DatePickerRange/DatePickerRange";
import {generateExcelFile, generateExcelFileName} from "../../helpers/downloadExcel";
import DescriptionIcon from '@material-ui/icons/Description';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { verifyFilterValues } from "../../helpers/validateFilter";
import {createParamsProcedure} from "../../helpers/correspondenceUtils";
import {mapCorrespondenceToExcel} from "../../helpers/excelMappers";

export const CorrespondenceManagmentScreen = () => {
  const classes = useStyles();
  const { modalAddOpen, modalSeeOpen, successMsg, successAlert, errorAlert, errorMsg } = useSelector((state: AppState) => state.ui);
  const { correspondence, paramResponseTime, correspondencePagination } = useSelector((state: AppState) => state.correspondence);
  const { activeCorrespondence, correspondence: communicationsManagment } = useSelector((state: AppState) => state.documentManagment);
  const { user } = useSelector((state: AppState) => state.auth);
  const date = activeCorrespondence?.createAt && moment((activeCorrespondence.createAt as firebase.firestore.Timestamp).toDate()).format("YYYY/MM/DD - h:mm:ss");
  const dispatch = useDispatch();
  const intl = useIntl();
  const [values, setValues] = useState({ trafficLight: 0, state: 0, inputType: 0, range: 0 });
  const [rangeDate, setRangeDate] = useState<{ startDate: Date, endDate: Date } | null>(null);
  const { data, value } = useSelector((state: AppState) => state.search);
  const { productionOffices } = useSelector((state: AppState) => state.trd);
  const paramsProcedure = createParamsProcedure(paramResponseTime);
  const [showInfoMessage, setShowInfoMessage] = useState(true);
  const [loadSuccess, setLoadSuccess] = useState(false);
  const [wasLoading, setWasLoading] = useState(false);

  useEffect(() => {
    if (correspondencePagination.isLoadingMore) {
      setWasLoading(true);
    } else if (wasLoading) {
      setWasLoading(false);
      setLoadSuccess(true);
      const timer = setTimeout(() => setLoadSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [correspondencePagination.isLoadingMore]);

  const handleChange = (event: React.ChangeEvent<{ name: string; value: string | number }>) => {
    const { name, value } = event.target;

    setValues((prevValues) => ({
      ...prevValues,
      [name]: isNaN(Number(value)) ? value : Number(value), // Convertir solo si es necesario
      ...(name === "trafficLight" && { state: value !== 0 ? 0 : prevValues.state }),
      ...(name === "state" && { trafficLight: value !== 0 ? 0 : prevValues.trafficLight }),
    }));
  };
  const handleDateRange = (range: any) => {
    setValues({ ...values, range: range });
    setRangeDate(range)
  }

  const handleExportExcel = async () => {
    try {
      const transformedData = await mapCorrespondenceToExcel(data!, paramResponseTime, intl, productionOffices);
      const fileName = generateExcelFileName("Correspondence");

      generateExcelFile("gestión_documental", transformedData, () => fileName);
    } catch (error) {
      console.error("Error al exportar a Excel:", error);
    }
  };

  const handleCleanFilter = () => {
    setValues({trafficLight: 0, state: 0, inputType: 0, range: 0})
    setRangeDate(null);
  }

  const onDeny = () => {
    dispatch(uiCloseModalAdd());
    dispatch(uiCloseModalEdit());
    dispatch(uiCloseModalDelete());
    dispatch(uiCloseModalSee());
    dispatch(setActiveCorrespondence(null));
    dispatch(setActiveCorrespondenceDocManagment(null));
    dispatch(setActiveExternalSender(null));
  };

  useEffect(() => {
    let filteredData = correspondence.filter((cor) => filterCorrespondence(cor, user?.id.toString() || ""));

    if (values.inputType !== 0) {
      filteredData = filteredData.filter((item) =>
          verifyFilterValues(item, paramResponseTime, null, undefined, undefined, values.inputType)
      );
    }

    if (values.trafficLight !== 0) {
      filteredData = filteredData.filter((item) =>
          verifyFilterValues(item, paramResponseTime, null, undefined, values.trafficLight, undefined, paramsProcedure)
      );
    }

    if (values.state !== 0) {
      filteredData = filteredData.filter((item) =>
          verifyFilterValues(item, paramResponseTime, null, String(values.state))
      );
    }

    if (rangeDate) {
      filteredData = filteredData.filter((item) =>
          verifyFilterValues(item, paramResponseTime, rangeDate)
      );
    }



    dispatch(loadCorrespondenceManagment(filteredData));
    dispatch(arraySearch(filteredData));
  }, [correspondence, values, rangeDate, user, paramResponseTime, dispatch]);

  return (
    <AppAnimate animation="transition.slideUpIn" delay={200}>
      <Paper square className="">
        <Box mb={3} p={3} fontSize={20}>
          <Box mb={3} fontSize={20}>
            <Grid container>
              <Grid item xs={5}>
                <Box display="flex" alignItems="center" style={{ gap: 12 }}>
                  <Button
                    size="large"
                    variant="contained"
                    color="secondary"
                    className={classes.btnAdd}
                    type="button"
                    onClick={() => dispatch(uiOpenModalAdd())}
                  >
                    <AddOutlinedIcon />
                    <FormattedMessage id="AddNewCommunication" />
                  </Button>
                  <Button
                    size="large"
                    variant="outlined"
                    onClick={() => {
                      if (user && user.idEntity) {
                        dispatch(startLoadAllCorrespondences(user.id, user.idEntity));
                      }
                    }}
                    disabled={correspondencePagination.isLoadingMore || !correspondencePagination.hasMore}
                    style={{
                      borderRadius: 8,
                      border: "2px solid #1a237e",
                      color: correspondencePagination.isLoadingMore || !correspondencePagination.hasMore ? "#9e9e9e" : "#1a237e",
                      backgroundColor: correspondencePagination.isLoadingMore || !correspondencePagination.hasMore ? "#f5f5f5" : "#e8eaf6",
                      textTransform: "none",
                      fontWeight: 600,
                      padding: "8px 20px",
                      fontSize: "0.875rem",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                    }}
                  >
                    {correspondencePagination.isLoadingMore ? (
                      <CircularProgress size={20} style={{ marginRight: 8, color: "#1a237e" }} />
                    ) : (
                      <CloudDownloadOutlinedIcon style={{ marginRight: 8 }} />
                    )}
                    <FormattedMessage id="LoadAllRecords" />
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={5}>
                <CustomizedSearch data={communicationsManagment} />
              </Grid>
            </Grid>
          </Box>


          <Box mb={5}>
            <Grid container spacing={3}>
              <Grid item xs={5}>
                <Box>
                  <label className={classes.typography}>
                    <FormattedMessage id="InputType" />*
                  </label>

                  <TextField
                    name="inputType"
                    variant="outlined"
                    select
                    onChange={handleChange}
                    value={values.inputType}
                    className={classes.myTextFieldRoot}
                    size="small"
                  >
                    <MenuItem value={0}>
                      <FormattedMessage id="All" />
                    </MenuItem>
                    <MenuItem value={CorrespondenceInputType.EP}>
                      <FormattedMessage id="ExternalProduced" />
                    </MenuItem>
                    <MenuItem value={CorrespondenceInputType.ER}>
                      <FormattedMessage id="ExternalReceived" />
                    </MenuItem>
                    <MenuItem value={CorrespondenceInputType.IR}>
                      <FormattedMessage id="InternalReceived" />
                    </MenuItem>
                    <MenuItem value={CorrespondenceInputType.IP}>
                      <FormattedMessage id="InternalProduced" />
                    </MenuItem>

                    <MenuItem
                      value={CorrespondenceInputType.OR}
                    //style
                    >
                      <FormattedMessage id="OtherShipmentsReceived" />
                    </MenuItem>
                    <MenuItem
                      value={CorrespondenceInputType.OP}
                    //style
                    >
                      <FormattedMessage id="OtherShipmentsProduced" />
                    </MenuItem>
                  </TextField>
                </Box>
                <Box>
                  <label className={classes.typography}>
                    <FormattedMessage id="SelectDateRange" />
                  </label>
                  <DatePickerRange range={rangeDate} handleDateRange={handleDateRange} />
                </Box>
              </Grid>
              <Grid item xs={5}>
                <Box>
                  <label className={classes.typography}>
                    <FormattedMessage id="TrafficLight" />:
                  </label>
                  <TextField
                    name="trafficLight"
                    variant="outlined"
                    value={values.trafficLight || 0}
                    onChange={handleChange}
                    select
                    className={classes.myTextFieldRoot}
                    size="small"
                    disabled={values.state !== 0}
                  >
                    <MenuItem value={0}>
                      <FormattedMessage id="All" />
                    </MenuItem>
                    <MenuItem value={1}>
                      <Box style={{display: "flex"}}>
                        <Box style={{height: "15px", width: "15px", background: "green", marginRight: 5, borderRadius: 3}}>
                        </Box>
                        <Box>
                          <FormattedMessage id="TrafficLightOpt1" />
                        </Box>
                      </Box>
                    </MenuItem>
                    <MenuItem value={2}>
                      <Box style={{display: "flex"}}>
                        <Box style={{height: "15px", width: "15px", background: "yellow", marginRight: 5, borderRadius: 3}}>
                        </Box>
                        <Box>
                          <FormattedMessage id="TrafficLightOpt2" />
                        </Box>
                      </Box>
                    </MenuItem>
                    <MenuItem value={3}>
                      <Box style={{display: "flex"}}>
                        <Box style={{height: "15px", width: "15px", background: "orange", marginRight: 5, borderRadius: 3}}>
                        </Box>
                        <Box>
                          <FormattedMessage id="TrafficLightOpt3" />
                        </Box>
                      </Box>
                    </MenuItem>
                    <MenuItem value={4}>
                      <Box style={{display: "flex"}}>
                        <Box style={{height: "15px", width: "15px", background: "red", marginRight: 5, borderRadius: 3}}>
                        </Box>
                        <Box>
                          <FormattedMessage id="TrafficLightOpt4" />
                        </Box>
                      </Box>
                    </MenuItem>
                    <MenuItem value={5}>
                      <FormattedMessage id="TrafficLightOpt5" />
                    </MenuItem>
                  </TextField>
                </Box>
                <Box>
                  <label className={classes.typography}>
                    <FormattedMessage id="State" />:
                  </label>
                  <TextField
                    name="state"
                    variant="outlined"
                    value={values.state}
                    onChange={handleChange}
                    select
                    className={classes.myTextFieldRoot}
                    size="small"
                    disabled={values.trafficLight !== 0}
                  >
                    <MenuItem value={0}>
                      <FormattedMessage id="All" />
                    </MenuItem>
                    <MenuItem
                      value={InternalCorrespondenceStatus.RESPONSE_ISSUED_ONTIME}
                    >
                      <FormattedMessage id="ResponseIssuedOnTime" />
                    </MenuItem>
                    <MenuItem
                      value={InternalCorrespondenceStatus.EXTEMPORANEOUS_RESPONSE}
                    >
                      <FormattedMessage id="ExtemporaneousResponse" />
                    </MenuItem>
                    <MenuItem value={InternalCorrespondenceStatus.UNANSWERED}>
                      <FormattedMessage id="Unanswered" />
                    </MenuItem>
                    <MenuItem
                      value={InternalCorrespondenceStatus.NO_ANSWER_REQUIRED}
                    >
                      <FormattedMessage id="NoAnswerRequired" />
                    </MenuItem>
                  </TextField>
                </Box>
              </Grid>
              <Grid item xs={2}>
                <Box>
                  <label className={classes.typography}>
                    <FormattedMessage id="DownloadFiles" />:
                  </label>
                  <Button
                    size="large"
                    variant="contained"
                    color="secondary"
                    className={classes.btnAdd}
                    type="button"
                    onClick={handleExportExcel}
                  >
                    <DescriptionIcon />
                  </Button>
                </Box>
                <Box>
                  <label className={classes.typography}>
                    <FormattedMessage id="Clean" />:
                  </label>
                  <Button
                    size="large"
                    variant="contained"
                    color="secondary"
                    className={classes.btnAdd}
                    type="button"
                    onClick={handleCleanFilter}
                  >
                    <DeleteForeverIcon />
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* Mensaje explicativo */}
          {showInfoMessage && (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={2}
              p={1.5}
              style={{
                backgroundColor: "#e8f4fd",
                borderLeft: "4px solid #2196f3",
                borderRadius: 4,
              }}
            >
              <Box display="flex" alignItems="center">
                <InfoOutlinedIcon
                  style={{ color: "#2196f3", marginRight: 8 }}
                />
                <Box>
                  <Typography variant="body2" style={{ fontWeight: 500 }}>
                    <FormattedMessage id="ProgressiveLoadMessage" />
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    <FormattedMessage id="ProgressiveLoadHint" />
                  </Typography>
                </Box>
              </Box>
              <IconButton
                size="small"
                onClick={() => setShowInfoMessage(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          )}

          {/* Contador de registros */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={2}
            p={1}
            style={{
              backgroundColor: "#f5f5f5",
              borderRadius: 4,
            }}
          >
            <Box display="flex" alignItems="center">
              <AutorenewIcon
                style={{ color: "#666", marginRight: 8 }}
              />
              <Typography variant="h6">
                <FormattedMessage id="ShowingRecords" />{" "}
                <strong style={{ color: "#4caf50" }}>
                  {communicationsManagment.length}
                </strong>{" "}
                {/*<FormattedMessage id="Of" />{" "}*/}
                {/*<strong style={{ color: "#4caf50" }}>*/}
                {/*  {correspondencePagination.totalCount}*/}
                {/*</strong>{" "}*/}
                <FormattedMessage id="AvailableRecords" />
              </Typography>
            </Box>
            <Typography variant="subtitle1" color="textSecondary">
              <FormattedMessage id="ResultsLoadProgressively" />
            </Typography>
          </Box>

          <CorrespondenceTable readOnly component="Correspondence" />

          {/* Estado de carga y botón cargar más */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            mt={2}
            style={{ gap: 16 }}
          >
            {/* Estado de carga */}
            {loadSuccess && (
              <Box
                display="flex"
                alignItems="center"
                p={1}
                px={2}
                style={{
                  backgroundColor: "#e8f5e9",
                  borderRadius: 20,
                  border: "1px solid #4caf50",
                }}
              >
                <CheckCircleOutlineIcon
                  style={{ color: "#4caf50", marginRight: 6, fontSize: 20 }}
                />
                <Typography variant="body2" style={{ color: "#2e7d32" }}>
                  {intl.formatMessage(
                    { id: "LoadedRecords" },
                    { count: communicationsManagment.length }
                  )}
                </Typography>
              </Box>
            )}

            {correspondencePagination.isLoadingMore && (
              <Box
                display="flex"
                alignItems="center"
                p={1}
                px={2}
                style={{
                  backgroundColor: "#fff3e0",
                  borderRadius: 20,
                  border: "1px solid #ff9800",
                }}
              >
                <CircularProgress
                  size={18}
                  style={{ color: "#ff9800", marginRight: 6 }}
                />
                <Typography variant="body2" style={{ color: "#e65100" }}>
                  Cargando registros...
                </Typography>
              </Box>
            )}

            {/* Botón cargar más */}
            {correspondencePagination.hasMore && (
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => {
                  if (user && user.idEntity) {
                    dispatch(
                      startLoadMoreCorrespondences(user.id, user.idEntity)
                    );
                    setLoadSuccess(false);
                  }
                }}
                disabled={correspondencePagination.isLoadingMore}
                style={{
                  borderRadius: 20,
                  borderColor: "#f44336",
                  color: "#f44336",
                  textTransform: "none",
                  padding: "6px 20px",
                }}
              >
                <StorageOutlinedIcon
                  style={{ color: "#f44336", marginRight: 6, fontSize: 20 }}
                />
                <FormattedMessage id="LoadMoreRecords" />
              </Button>
            )}
          </Box>

          <CustomizedDialog
            open={modalAddOpen}
            cancelBtn={true}
            onDeny={onDeny}
            title={`${intl.formatMessage({ id: "NewCommunication" })}`}
            content={<CorrespondenceForm edit={false} isDocManagment />}
            textButton="Accept"
          />

          <CustomizedWindow
            open={modalSeeOpen}
            content={<SettledDetails component={"OTHER"} />}
            onDeny={onDeny}
            title={`${intl.formatMessage({ id: "Settled" })} No. ${activeCorrespondence?.id
              } -  ${date}`}
          />

          {successMsg && (
            <MyAlert
              open={successAlert}
              typeAlert="success"
              message={successMsg}
              time={2000}
              handleClose={() => dispatch(uiCloseSuccessAlert())}
            />
          )}

          <MyAlert
            open={errorAlert}
            typeAlert="error"
            message={errorMsg ? errorMsg : "SavingDataError"}
            time={2000}
            handleClose={() => dispatch(uiCloseErrorAlert())}
          />
        </Box>
      </Paper>
    </AppAnimate>
  );
};
